import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    getProfRateById (consultationType) {
        return client().get(`rates/${consultationType}`)
    }
}


// WEBPACK FOOTER //
// ./src/repositories/ProfessionalRateRepository.js